import moment from "moment"
import { ButtonLoader } from "../Button"
import { ButtonClose } from "../ChatCloseButton"
import { getInputTypeGeneralRegistration } from "../GetInputType/farmerProfile"
import "./styles.scss"

const actions = [
  { type: "edit", description: "Editar" },
  { type: "copy", description: "Copiar Campo" },
]

export const StepRegisterFields = ({
  fields,
  editIndex,
  values,
  chat,
  editedChatFields,
  handleChangeChatField,
  handleSave,
  handleEdit,
  handleCopy,
  stepIndex,
  loadingField,
  handleCancel
}) => {
  const renderButtons = (action, index, stepIndex, answer, field, translated) => {
    const iconStyles = { color: "#99AA99" }

    const iconTypeMap = {
      edit: "pencil",
      copy: "copy",
    }

    const actionHandlers = {
      copy: (e) => handleCopy(e, answer),
      edit: () => handleEdit(field, stepIndex),
      talk: () => handleMessageToRequestResponse(id, translated, answer, stepIndex),
    }

    const typeIcon = iconTypeMap[action.type]
    const handler = answer === "" ? actionHandlers.add : actionHandlers[action.type]
    const icon = answer === "" ? iconTypeMap.add : typeIcon
 
    return ( 
      <div key={index} className="steps__item-field-actions-buttons" onClick={handler}>
        <i title={action.description} className={`fi fi-rr-${icon}`} style={iconStyles}></i>
      </div>
    )
  }

  

  return (
    fields &&
    fields.map(({ field, translated }, indexField) => (
      <div key={indexField} className="steps__item">
        <div className="steps__item-field">
          <div className={`steps__item-field-details`}>
            <span className="details-name">{translated}</span>
            <div key={field} className="details-answer">
              {editIndex === field ? (
                <div className="details-answer__edit-field">
                  <div className="edit-field-input">
                    {getInputTypeGeneralRegistration(
                      field,
                      editedChatFields,
                      handleChangeChatField,
                      translated
                    )}
                  </div>
                  <ButtonLoader
                    loading={loadingField}
                    messageProcess="Salvando"
                    label="Salvar"
                    variant="outline"
                    handleClick={() => handleSave(field, editedChatFields[field], stepIndex)}
                  />
                  <ButtonClose handleClick={handleCancel} />
                </div>
              ) : (
                <span>{field === 'birthday' && chat[field] ? moment(chat[field], "YYYY-MM-DD").format("DD/MM/YYYY") : chat[field] || "--"}</span>
              )}
            </div>
          </div>
          <div className="steps__item-field-actions">
            {editIndex === field ? null : chat[field] === "" || !chat[field] ? (
              <div
                className="steps__item-field-actions-buttons"
                onClick={() => handleEdit(field, stepIndex)}>
                <i
                  title="Adicionar Informação"
                  className="fi fi-rr-add"
                  style={{ color: "#99AA99" }}></i>
              </div>
            ) : (
              actions.map((action, index) =>
                renderButtons(action, index, stepIndex, chat[field], field, translated),
              )
            )}
          </div>
        </div>
      </div>
    ))
  )
}

export const StepFields = ({ fields }) => {
  return (
    fields &&
    fields.map(({ title, info }, indexField) => (
      <div key={indexField} className="steps__item">
        <div className="steps__item-field">
          <div className={`steps__item-field-details`}>
            <span className="details-name">{title}</span>
            <div className="details-answer">
              <span>{info ? info : "--"}</span>
            </div>
          </div>
        </div>
      </div>
    ))
  )
}
